module.exports = __webpack_public_path__ + "img/toutu-fuwuwangdain@1x.15942df5.png";